import { SkeletonItem } from "@fluentui/react-components";
/**
 * Skeleton for welcome card to display on loading
 * @returns 
 */
export default function WelcomeCardSkeleton() {

    return (
        <div data-testid="welcome-card-skeleton">
            <div className="welcome-card-skeleton-title">
                <div className="welcome-card-title-col-1">
                </div>
                <div className="welcome-card-title-col-2">
                </div>
                <div className="welcome-card-title-col-3">
                    <SkeletonItem appearance="translucent" className="col-2-skeleton-1" size={16} />
                </div>
                <div className="welcome-card-title-col-4">
                </div>
                <div className="welcome-card-title-col-5">
                    <SkeletonItem appearance="translucent" className="col-4-skeleton-1" size={16} />
                </div>
            </div>
            <div className="welcome-card-skeleton-top">
                <div className="welcome-card-col-1">
                    <SkeletonItem appearance="translucent" className="circle-skeleton" shape="circle" size={24} />
                    <SkeletonItem appearance="translucent" className="col-1-skeleton-1" size={16} />
                    <SkeletonItem appearance="translucent" className="col-1-skeleton-2" size={16} />
                </div>
                <div className="welcome-card-col-3">
                    <SkeletonItem appearance="translucent" className="col-2-skeleton-1" size={16} />
                    <SkeletonItem appearance="translucent" className="col-2-skeleton-2" size={16} />
                    <SkeletonItem appearance="translucent" className="col-2-skeleton-4" size={16} />
                </div>
                <div className="welcome-card-col-4">
                    <SkeletonItem appearance="translucent" className="col-3-skeleton-1" size={16} />
                    <SkeletonItem appearance="translucent" className="col-3-skeleton-2" size={16} />
                    <SkeletonItem appearance="translucent" className="col-3-skeleton-3" size={16} />
                </div>
                <div className="welcome-card-col-5">
                    <SkeletonItem appearance="translucent" className="col-4-skeleton-1" size={16} />
                    <SkeletonItem appearance="translucent" className="col-4-skeleton-2" size={16} />
                    <SkeletonItem appearance="translucent" className="col-4-skeleton-4" size={16} />
                </div>
            </div>
            <div className="welcome-card-skeleton-bottom">
                <SkeletonItem appearance="translucent" className="row-4-skeleton-1" size={32} />
            </div>
        </div>
    )
}